import { render, staticRenderFns } from "./Sponsers.vue?vue&type=template&id=1fd2a4bc&scoped=true"
import script from "./Sponsers.vue?vue&type=script&lang=js"
export * from "./Sponsers.vue?vue&type=script&lang=js"
import style0 from "./Sponsers.vue?vue&type=style&index=0&id=1fd2a4bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd2a4bc",
  null
  
)

export default component.exports